<p-panel [toggleable]="true">
  <ng-template pTemplate="header">
    <div class="report-card-header">
      <span class="report-icon"><i class="fa fa-download"></i></span>
      <span class="report-card-title">Export DAD Exchange report (CSV)</span>
    </div>
  </ng-template>

  <div class="report-card-body">
    <div class="report-filters">
      <div class="report-filter-field">
        <p-floatLabel>
          <p-dropdown [(ngModel)]="csvSelectedOption.date" [options]="usageMonth"/>
          <label>Usage Month</label>
        </p-floatLabel>
      </div>
      <div class="report-filter-field">
        <p-floatLabel>
          <p-dropdown (onChange)="changeCsvOptions()" [(ngModel)]="csvSelectedOption.exchange"
                      [options]="exchangeNamesList"
                      inputId="Exchange"/>
          <label>Exchange</label>
        </p-floatLabel>
      </div>
      <div class="report-filter-field">
        <p-floatLabel>
          <p-dropdown [(ngModel)]="csvSelectedOption.mode" [options]="csvOptions" inputId="Mode"/>
          <label>Mode</label>
        </p-floatLabel>
      </div>
    </div>
    <button (click)="exportCSV()" class="report-export-btn" icon="fa fa-download pr-2" iconPos="left" label="Export" pButton
            type="button"></button>
  </div>
</p-panel>
